import * as actions from "./actionsType";

const initialData = {
  loaderEstados: false,
  estados: null,
  estadosFalla: null,
  saveLoaderEstados: false,
  estadosFormError:null
};

export default function EstadosReducer(state = initialData, action) {
  switch (action.type) {
    case actions.LOADER_ESTADOS:
      return { ...state, loaderEstados: action.payload };

    case actions.GET_ESTADOS:
      return { ...state, estados: action.payload };

    case actions.ESTADOS_FALLA:
      return { ...state, estadosFalla: action.payload };

    case actions.SAVE_LOADER_ESTADOS:
      return { ...state, saveLoaderEstados: action.payload };

    case actions.FORM_ESTADOS_FAIL:
      return { ...state, estadosFormError: action.payload };
      
    default:
      return state;
  }
}
